import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["productName", "sku", "barcode", "generateButton"]

  connect() {
    this.updateButtonState()
  }

  updateButtonState() {
    if (this.hasGenerateButtonTarget) {
      const hasProductName = this.productNameTarget.value.trim().length > 0
      this.generateButtonTarget.disabled = !hasProductName
    }
  }

  async generate() {
    const productName = this.productNameTarget.value.trim()
    if (!productName) return

    const baseSku = this.generateAbbreviation(productName)
    const finalSku = await this.ensureUniqueSku(baseSku)

    this.skuTarget.value = finalSku
    this.updateBarcode()
  }

  generateAbbreviation(productName) {
    const words = productName.split(/\s+/).filter(w => w.length > 0)
    let sku = ''

    if (words.length > 1) {
      sku = words.map(word => {
        const firstChar = word.match(/[A-Z0-9]/i)
        return firstChar ? firstChar[0] : ''
      }).join('')
    } else {
      sku = productName.substring(0, 6)
    }

    sku = sku.toUpperCase().replace(/[^A-Z0-9]/g, '')
    return sku.substring(0, 20)
  }

  async ensureUniqueSku(baseSku) {
    const response = await fetch(`/supply_cases/check_sku?sku=${encodeURIComponent(baseSku)}`)
    const data = await response.json()

    if (data.available) {
      return baseSku
    } else {
      return data.suggested_sku
    }
  }

  updateBarcode() {
    if (this.hasBarcodeTarget) {
      const sku = this.skuTarget.value.trim()
      if (sku) {
        const barcode = `SUPPLY:${sku.toUpperCase().replace(/\s+/g, '-')}`
        this.barcodeTarget.value = barcode
      }
    }
  }
}
